import Vue from 'vue'
import Router from 'vue-router'
import Profile from './components/views/auth/profile/AppProfile.vue'
import Login from './components/views/auth/AppLogin.vue'
import ForgotPassword from './components/views/auth/AppForgotPassword.vue'
import AppProfileAccountInformation from './components/views/auth/profile/AppProfileAccountInformation.vue'
import AppProfileChangePassword from './components/views/auth/profile/AppProfileChangePassword.vue'
import AppVehiclesNew from './components/views/vehicles/AppVehicleNew.vue'
import AppNotFound from './components/views/error-pages/AppNotFound404.vue'
import AppVehicleInfo from "@/components/views/vehicles/AppVehicleInfo.vue";
import AppDevices from "./components/views/devices/AppDevices";
import AppBeacons from "./components/views/beacons/AppBeacons";
import AppUsers from "./components/views/users/AppUsers";
import AppVehicles from "./components/views/vehicles/AppVehicle";
import AppVehiclesTrack from "./components/views/real-time/AppVehiclesTrack";
import AppOperators from "./components/views/operators/AppOperators";
import AppOperatorsEditCreate from "./components/views/operators/AppOperatorsEditCreate";
import AppAlerts from "./components/views/alerts/machine/AppAlerts";
import AppAlertsServiceOrders from "./components/views/alerts/orders/AppAlertsServiceOrders";
import AppChangePassword from "./components/views/auth/AppChangePassword";
import AppConfirmAccount from "./components/views/auth/AppConfirmAccount";
import AppAnalysis from "./components/views/analysis/AppAnalysis";
import AppSettings from "./components/views/settings/AppSettings";
import AppWebhook from "./components/views/webhook/AppWebhook";
import AppAlertsDictionary from "./components/views/alerts/machine/dictionary/AppAlertsDictionary";
import AppChecklists from "./components/views/checklist/AppChecklists";
import AppChecklistsNew from "./components/views/checklist/AppChecklistsNew";
import AppActivitiesList from "./components/views/configuration-list/AppActivitiesList";
import AppApontamentos from "./components/views/configuration-list/AppApontamentos";
import AppConfigurationList from "./components/views/configuration-list/AppConfigurationList";
import AppConfigurationListForm from "./components/views/configuration-list/AppConfigurationListForm";
import AppAnomalias from "./components/views/anomalias/AppAnomalias";
import AppFields from "./components/views/fields/AppFields";
import AppHeader from "./components/layout/AppHeader";
import AppLogout from "@/components/views/auth/AppLogout";
import AppOrgInvite from "@/components/views/auth/AppOrgInvite";
import AppOperationsCenterConnection from "@/components/views/settings/AppOperationsCenterConnection";
import AppOperationsCenterConnectionCallback from "@/components/views/settings/AppOperationsCenterConnectionCallback";
import AppDashboard from "@/components/views/dashboard/AppDashboard";
import AppSignUp from "@/components/views/auth/AppSignUp";
import AppCosts from '@/components/views/costs/AppCosts.vue';
import AppAlertsCoa from '@/components/views/alerts-coa/coa/AppAlertsCoa';
import AppAlertsCoaHistorical from '@/components/views/alerts-coa/historical/AppAlertsCoaHistorical'
import AppAlertsCoaSensor from '@/components/views/alerts-coa/sensors/AppAlertsCoaSensor';
import AppAlertsCoaAlertsConfig from '@/components/views/alerts-coa/alerts-config/AppAlertsCoaAlertsConfig';
import AppMachineReportCOA from '@/components/views/alerts-coa/machine-report/AppMachineReportCOA.vue';
import AppMachineReport from '@/components/views/machine-report/AppMachineReport';
import eventBus from './eventBus'
import AppOperations from "@/components/views/agriculture/operations/AppOperations.vue";
import AppOperationsExportHistory from "@/components/views/agriculture/file-export/AppOperationsExportHistory.vue";
import AppWorkAnalyzer from "@/components/views/agriculture/work-analyzer/AppWorkAnalyzer.vue";
import AppImplements from "./components/views/implements/AppImplement";
import AppImplementForm from "./components/views/implements/AppImplementForm";
import AppOrganizationSettings from "@/components/views/organization-settings/AppOrganizationSettings.vue";
import AppAgroSettings from "@/components/views/organization-settings/AppAgroSettings.vue";
import AppVehiclesGroup from "./components/views/vehicles-group/AppVehiclesGroup.vue";
import AppFleetReport from './components/views/fleet-report/AppFleetReport.vue'
import AppWorkDataUpload from './components/views/work-data-upload/AppWorkDataUpload.vue';
import store from "@/store/store";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {path: '*', name: 'not-found', component: AppNotFound},
        {path: '/login/:confirmed?', name: 'login', component: Login},
        {path: '/signup', name: 'signup', component: AppSignUp},
        {path: '/forgot-password', name: 'forgot-password', component: ForgotPassword},
        {path: '/change-password/:token', name: 'change-password', component: AppChangePassword},
        {path: '/confirm-acc/:token', name: 'confirm-acc', component: AppConfirmAccount},
        {path: '/logout', name: 'logout', component: AppLogout},
        {path: '/invite', name: 'invite', component: AppOrgInvite},

        {path: '/', name: 'home', component: AppHeader, meta: {requiresAuth: true}, redirect: {name: 'vehicles-track'},
          children: [

                {path: '/profile', name: 'profile', component: Profile},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //PROFILE

                {path: '/profile/account-information',name: 'profile-account-information',component: AppProfileAccountInformation},
                {path: '/profile/change-password',name: 'profile-change-password',component: AppProfileChangePassword},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                // ORGANIZATION SETTINGS
                {path: '/organization/settings', name: 'organization-settings', component: AppOrganizationSettings},
                {path: '/organization/agro-settings', name: 'agro-settings', component: AppAgroSettings},
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                // USERS
                {path: '/users', name: 'users', component: AppUsers},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //VEHICLES
                {path: '/vehicles', name: 'vehicles', component: AppVehicles},
                {path: '/vehicles/new', name: 'vehicles-new', component: AppVehiclesNew},
                // {path: '/track', name: 'vehicles-track', component: AppVehiclesTrack, meta: {requiresAuth: true}},
                {path: '/track', name: 'vehicles-track', component: AppVehiclesTrack},
                {path: '/vehicles/:id', name: 'vehicles-edit', component: AppVehicleInfo},
                {path: '/vehicles-group', name: 'vehicles-group', component: AppVehiclesGroup},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //DEVICES
                {path: '/devices', name: 'devices', component: AppDevices},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //BEACONS
                {path: '/beacons', name: 'beacons', component: AppBeacons},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //COSTS
                {path: '/costs', name: 'costs', component: AppCosts},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //Análises
                {path: '/analysis', name: 'analysis', component: AppAnalysis},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //Operadores
                {path: '/operators', name: 'operators', component: AppOperators},
                {path: '/operators/:id', name: 'operators-edit', component: AppOperatorsEditCreate},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                // alertas
                // {path: '/alerts', name: 'alerts', component: AppAlerts},
                {path: '/alerts/machine', name: 'alerts-machine', component: AppAlerts},
                {path: '/alerts/serviceOrders', name: 'alerts-orders', component: AppAlertsServiceOrders},


                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                // Checklist
                {path: '/settings/checklists', name: 'checklists', component: AppChecklists},
                {path: '/settings/checklists/new:org_id?', name: 'new-checklist', component: AppChecklistsNew},
                {path: '/settings/checklists/new:org_id?:checklist_id?', name: 'new-pre-existent-checklist', component: AppChecklistsNew},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                // Lista de atividades, apontamentos e configuração do aplicatvio
                {path: '/settings/activities-list', name: 'activities-list', component: AppActivitiesList},
                {path: '/settings/apontamentos', name: 'apontamentos', component: AppApontamentos},
                {path: '/settings/configuration-list', name: 'configuration-list', component: AppConfigurationList},
                {path: '/settings/configuration-list/new:org_id?', name: 'new-configuration-list', component: AppConfigurationListForm},
                {path: '/settings/configuration-list/new:org_id?:list_id?', name: 'edit-configuration-list', component: AppConfigurationListForm},


                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                // Ajustes
                {path: '/settings', name: 'settings', component: AppSettings},
                {path: '/settings/operationsCenterConnection', name: 'operations-center-connection', component: AppOperationsCenterConnection},
                {path: '/settings/operationsCenterConnection/callback', name: 'operations-center-connection-callback', component: AppOperationsCenterConnectionCallback},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                // Webhook
                {path: '/settings/webhook', name: 'webhook', component: AppWebhook},


                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //Máquinas Homologadas
                {path: '/settings/machine/report/:type?/:modelId?', name: 'machine-report', component: AppMachineReport},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                // Dicionario alertas
                {path: '/alerts/dictionary', name: 'alerts-dictionary', component: AppAlertsDictionary},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //Anomalias
                {path: '/anomalias', name: 'anomalias', component: AppAnomalias},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //Agriculture
                {path: '/agriculture/operations', name: 'agriculture-operations', component: AppOperations},
                {path: '/agriculture/exportHistory', name: 'agriculture-export-history', component: AppOperationsExportHistory},
                {path: '/agriculture/work-analyzer', name: 'agriculture-work-analyzer', component: AppWorkAnalyzer},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //Fields
                {path: '/fields', name: 'fields', component: AppFields},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //Dashboard
                {path: '/dashboard', name: 'dashboard', component: AppDashboard},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //Alerts-Coa
                {path: 'alerts-coa/coa', name: 'alerts-coa', component: AppAlertsCoa},
                {path: 'alerts-coa/sensor', name: 'alerts-sensor', component: AppAlertsCoaSensor},
                {path: 'alerts-coa/historical', name: 'alerts-historical', component: AppAlertsCoaHistorical},
                {path: 'alerts-coa/alerts', name: 'alerts-coa-alerts', component: AppAlertsCoaAlertsConfig},
                {path: 'alerts-coa/machine-report', name: 'machine-report-coa', component: AppMachineReportCOA},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //IMPLEMENTS
                {path: '/implements', name: 'implements', component: AppImplements},
                {path: '/implements/new:org_id?', name: 'new-implement', component: AppImplementForm},
                {path: '/implements/edit:org_id?:implement_id?', name: 'edit-implement', component: AppImplementForm},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                // Relatório de Frota
                {path: '/settings/fleetReport', name: 'fleet-report', component: AppFleetReport},

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                // Upload de arquivos de trabalho
                {path: '/settings/work-data-upload', name: 'work-data-upload', component: AppWorkDataUpload},
             ]
        },
    ]
});

router.beforeEach(async (to, from, next) => {
  // Verifica saida de Análises e se o usuário tem algo não salvo
  if (from.name === "analysis") {
    let values = { to, from, next };
    eventBus.$emit('analysis-event', values);
    return;
  }

  eventBus.$emit('route-loading', true);

  // Adiciona background nas views específicas
  if (to.name === 'login' || to.name === 'signup' || to.name === 'forgot-password' ||
    to.name === 'change-password' || to.name === 'invite') {
    document.body.classList.add("background");
  } else if (to.name === 'not-found') {
    document.body.classList.add("error");
  } else {
    document.body.classList.remove("background");
  }

  if (to.name === 'login') {
    await store.dispatch('logout');
    return next();
  }

  if (!to.matched.some(record => record.meta.requiresAuth)) {
    return next();
  }

  let data = null;
  try {
    data = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE));
  } catch {
    return next({ name: 'login' });
  }

  if (data == null) {
    return next({ name: 'login' });
  }

  if (Math.floor(Date.now() / 1000) < data.expiration) {
    return next();
  }

  try {
    await store.dispatch('refreshTokenAction');

    return next();
  } catch (error) {
    const status = error?.response?.status ?? error?.status;

    if (status === 503 || status === 408) {
      eventBus.$emit('show-toast', {
        type: 'error',
        message: 'Serviço temporariamente indisponível. Tente novamente.'
      });

      eventBus.$emit('route-loading', false);
      return next(false); // Permanece na mesma página
    }

    return next({ name: 'login' });
  }
});

router.afterEach(() => {
  eventBus.$emit('route-loading', false);
});

router.onError(() => {
  eventBus.$emit('route-loading', false);
});

export {
    router
}
